<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="scarListWrap">
        <div class="imgUploadSet">
          <div class="uploadItem">
            <div class="uploadImgWrap">
              <div clas="viewImg">
                <img src="@/assets/images/plusBtn.png">
              </div>
              <input type="file" v-if="isIOS" @change="onFileChange" multiple="" class="boneImg"/>
              <input type="file" v-else @change="onFileChange" multiple="" class="boneImg"/>
            </div>
            <div class="uploadImgWrap" @change="sense(0)">
              <img :src="uploadData.url[0]" />
            </div>
            <div class="uploadImgWrap" @change="sense(1)">
              <img :src="uploadData.url[1]" />
            </div>
            <div class="uploadImgWrap" @change="sense(2)">
              <img :src="uploadData.url[2]" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { getCookie } from '../../utils/cookieNew'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '흉터관리',
        prevUrl: '/'
      },
      IsSurgeryInfo: false,
      mutatedDate: '',
      uploadData: {
        url: []
      },
      isIOS: false
    }
  },
  created () {
    this.setDeviceType()
  },
  computed: {
    ...mapGetters([
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([

    ]),
    setDeviceType () {
      if (getCookie('device') === 'I') {
        this.isIOS = true
      } else {
        this.isIOS = false
      }
    },
    sense (order) {
      console.log('감지됨', order)
    },
    async onFileChange (e) {
      await this.uploadImgInsert(e)
      if (e.target.files.length > 3) {
        this.SET_POPUP(true)
        this.popupSet.content = '이미지를 3개이상 선택할 수 없습니다.'
      }
    },
    async uploadImgInsert (e) {
      console.log('이거 가져갈 수 있어?', e.target.files.length)
      const fileArray = []
      for (let i = 0; i < e.target.files.length; i++) {
        if (i < 3) {
          fileArray.push(URL.createObjectURL(e.target.files[i]))
        }
      }
      console.log('뭘 담았음?', fileArray)
      this.uploadData.url = fileArray
      this.uploadImgFetch()
    },
    async uploadImgFetch () {
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  .setSurgeryDate {
    .actionDiv {
      h5 {
        font-family: NotoSansCJKkr;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
      }

      .buttonBox {
        margin: 7px 0 0 0;

        button {
          width: 54px;
          height: 25px;
          border-radius: 5px;
          -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
          background-color: #9e9e9e;
          border: 0;
          font-family: NotoSansCJKkr;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 25px;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
        }
      }
    }

    .findSurgeryItem {
      text-align: center;

      h5 {
        font-family: NotoSansCJKkr;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 25px;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
      }

      p {
        font-family: NotoSansCJKkr;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 25px;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
      }
    }
  }
  .imgUploadSet {
    margin: 25px 0 0 0;
    .uploadItem {
      .boneImg {
        width:100%;
      }
      display:flex;
      input {

      }
      .uploadImgWrap {
        width:25%;
        display: flex;
        justify-content: center;
        align-items: center;
        .viewImg {
          img {

          }
        }
        img {
          width:100%;
        }
      }
    }
  }

</style>
